import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { BasicPage, Route } from '@luks/ui';
import { graphql, PageProps } from 'gatsby';
import React from 'react';

import {
  useContentPageQuery,
  useContentPageRevisionQuery,
} from '../../generated/preview-queries';
import { StandardFrame } from '../commons/frame/standard-frame';
import { useContent } from '../commons/preview';
import { SEO } from '../commons/Seo';
import { mapBasicPage, mapBasicPageMetadata } from '../mappers/pages/BasicPage';

export const query = graphql`
  query ContentPage($remoteId: String!) {
    content: drupalContentPage(remoteId: { eq: $remoteId }) {
      ...BasicPage
    }
  }
`;

type ContentPageProps = Omit<
  PageProps<{ content?: BasicPageFragment }, SilverbackPageContext>,
  'children'
>;

export function ContentPageComponent({ data, pageContext }: ContentPageProps) {
  const content = useContent(
    useContentPageQuery,
    useContentPageRevisionQuery,
    data.content,
    pageContext,
  );
  return content ? (
    <>
      <SEO {...mapBasicPageMetadata(content)} />
      <Route
        definition={BasicPage}
        input={mapBasicPage(content)}
        intl={{ locale: 'de', defaultLocale: 'de' }}
      />
    </>
  ) : null;
}

export default function ContentPageTemplate(props: ContentPageProps) {
  return (
    <StandardFrame editUrl={`/node/${props.pageContext.remoteId}/edit`}>
      <ContentPageComponent {...props} />
    </StandardFrame>
  );
}
